import React from 'react'
import { FieldErrors } from '../../../../../../hooks/useForm'
import Input from '../../../../../atoms/form/input/Input'
import InlineGroup from '../../../../../atoms/inlinegroup/InlineGroup'
import Toggle from '../../../../../atoms/toggle/Toggle'
import { getFieldError } from './getFieldError'

interface Props {
  onChange: (writtenResponseField: API.WrittenResponseFieldRequest) => void
  writtenResponseField: API.WrittenResponseFieldRequest
  index: number
  fieldErrors?: FieldErrors
}

const DEFAULT_WORD_LIMIT = 300

export const WrittenResponseField: React.FC<Props> = ({ writtenResponseField, onChange, fieldErrors, index }) => {
  return <InlineGroup>
    <Toggle onUpdate={(isOn: boolean) => {
      onChange({
        type: 'written_response',
        config: {
          ...writtenResponseField.config,
          type: 'written_response',
          hasWordLimit: isOn,
          ...(isOn ? { wordLimit: DEFAULT_WORD_LIMIT } : {})
        }
      })
    }} checked={writtenResponseField.config.hasWordLimit} label='Word limit' reverse small />
    {writtenResponseField.config.hasWordLimit && <Input
      className="ml-2"
      type='text'
      small
      reverse
      label='Words'
      value={writtenResponseField.config.wordLimit}
      onChange={(e) => {
        onChange({
          type: 'written_response',
          config: {
            ...writtenResponseField.config,
            wordLimit: Number(e.target.value)
          }
        })
      }}
      error={getFieldError(index, 'wordLimit', fieldErrors)}
    />}
  </InlineGroup>
}